import { render } from "./TableTransactions.vue?vue&type=template&id=8bbfe2d0&scoped=true"
import script from "./TableTransactions.vue?vue&type=script&lang=js"
export * from "./TableTransactions.vue?vue&type=script&lang=js"

import "./TableTransactions.vue?vue&type=style&index=0&id=8bbfe2d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbfe2d0"]])

export default __exports__